export default __webpack_public_path__ + "static/national-yards-mobile-b3131d47f58caffd2440ae79d4719b40.svg";